import { Outlet, useNavigate } from "react-router-dom";

import { MdLogout } from "react-icons/md";

import MenuBar from "../Menubar/index.js";
import Sidebar from "../Sidebar/index.js";

import "./style.css";

function AdminLayout() {
    const navigate = useNavigate();

    return (
        <>
            <div id="main-app">
                <Sidebar />
                <div id="main-content">
                    <div id="main-header">
                        <h5>{/* Dashboard */}</h5>
                        <MdLogout
                            id="logout-button"
                            className="clickable"
                            onClick={() => {
                                localStorage.clear();
                                navigate("/login");
                            }}
                        />
                        {/* <MenuBar /> */}
                    </div>

                    <Outlet />
                </div>
            </div>
        </>
    );
}

export default AdminLayout;
